/* global Fw, actionPath, tinyMCE, grecaptcha */
(function() {
    'use strict';

    let utils_recaptcha2, form_validateForm;

    function submitCustomizedForm(captcha) {
        const btn = $(this);
        const form = btn.closest('.js-form');
        const widgetId = btn.attr('data-widget-id');

        if (btn.hasClass('is-processing') || btn.hasClass('disabled')) {
            return false;
        }
        
        // Validate required fields
        form_validateForm(form);

        if (form.hasClass('has-error')) {
            // Reset if there is any error
            grecaptcha.reset(widgetId);
        } else {
            // No errors
            btn.addClass('is-processing disabled');
            let formdata;
            
            // Fetch the real content from the tinymce editors
            form.find('.mce-enabled').each(function() {
                if (window.tinymce) {
                    this.value = tinymce.get(this.id).getContent();
                }
            });
            // Init FormData
            formdata = new FormData(form[0]);
            formdata.append('ajax', 'true');

            $.ajax({
                method: 'post',
                type: 'post',
                url: actionPath + 'submitGenForm',
                data: formdata,
                cache: false,
                contentType: false,
                processData: false,
                success: function(res) {
                    grecaptcha.reset(widgetId);
                    btn.removeClass('is-processing disabled');
                    if (res.indexOf('success') !== -1) {
                        let valuesArray = res.split(',').map(value => value.trim());
                        form.removeClass('is-checked');
                        form.find('.has-value, .success').removeClass('has-value success').val('');
                        try {
                            form[0].reset();
                        } catch (err) {
                        }
                        $('.js-form-success-message.form-sent', form).append("<br/> Your Submission ID: " + valuesArray[1]);
                        $('.js-form-success-hide', form).slideUp(300);
                        $('.js-form-success-message.form-sent', form).slideDown(300);
                    } else {
                        console.error(res);
                    }
                }
            });
        }
    }

    let init = function() {
        utils_recaptcha2 = Fw.component.models().utils.recaptcha2;
        form_validateForm = Fw.component.models().form.validateForm;

        $('.submit-customized-form-btn').each(function() {
            utils_recaptcha2(this, submitCustomizedForm);
        });
    };

    $(window).ready(init);

})();
